import { render, staticRenderFns } from "./addMessage.vue?vue&type=template&id=405d9cdb&scoped=true&"
import script from "./addMessage.vue?vue&type=script&lang=ts&"
export * from "./addMessage.vue?vue&type=script&lang=ts&"
import style0 from "./addMessage.vue?vue&type=style&index=0&id=405d9cdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405d9cdb",
  null
  
)

export default component.exports